/**
 * Step 2A の「再生 + ダウンロード」(DOWNLOAD) ラジオ用の小アイコン。
 * 再生三角を円で囲み、右下にダウンロード矢印を添えた「+α」の表現。
 * 並べた時に「{@link ShareViewIcon} よりも権限が広い」ことを記号で伝える。
 */
export function ShareDownloadIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="9" />
      <path d="M8.5 7 L15.5 11 L8.5 15 Z" fill="currentColor" stroke="none" />
      <path d="M22 16 V24" />
      <path d="M18.5 21 L22 24.5 L25.5 21" />
    </svg>
  )
}
